export const trackingFormModel = {
  formId: "tracking-form",
  formFields: {
    trackingNumbers: {
      name: "trackingNumbers",
      label: "Enter up to 25 tracking numbers",
      placeholder: "Enter tracking number",
      errMsg: {
        required: "Please enter a tracking number.",
        invalid: "Please enter a valid tracking number.",
      },
    },
  },
};

export const reportsFormModel = {
  formId: "reports-form",
  formFields: {
    fromMonth: {
      name: "fromMonth",
      placeholder: "05",
      errMsg: {
        required: "Month is required",
        invalid: "Month is invalid",
      },
    },
    fromDay: {
      name: "fromDay",
      placeholder: "16",
      errMsg: {
        required: "Day is required",
        invalid: "Day is invalid",
      },
    },
    fromYear: {
      name: "fromYear",
      placeholder: "21",
      errMsg: {
        required: "Year is required",
        invalid: "Year is invalid",
      },
    },
    toMonth: {
      name: "toMonth",
      placeholder: "05",
      errMsg: {
        required: "Month is required",
        invalid: "Month is invalid",
      },
    },
    toDay: {
      name: "toDay",
      placeholder: "16",
      errMsg: {
        required: "Day is required",
        invalid: "Day is invalid",
      },
    },
    toYear: {
      name: "toYear",
      placeholder: "21",
      errMsg: {
        required: "Year is required",
        invalid: "Year is invalid",
      },
    },
    sortReportOption: {
      name: "sortReportOption",
      errMsg: {
        required: "Required",
      },
    },
    typeReportOption: {
      name: "typeReportOption",
      errMsg: {
        required: "Required",
      },
    },
  },
};

export const proofOfDeliveryForm = {
  formId: "proof-of-delivery-form",
  formFields: {
    trackingNumbers: {
      name: "trackingNumbers",
      label: "Enter up to 25 tracking numbers",
      placeholder: "Enter tracking number",
      errMsg: {
        required: "Tracking number is required",
        invalid: "Tracking number is invalid",
      },
    },
  },
};
